<script setup>
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const route = proxy.$route;
const router = proxy.$router;

// --- Computed ---

const tableName = computed(() => route.params.component);

const component = computed(() => {
    return store.state.components.items.find(o => o.tableName === tableName.value);
});

const isForm = computed(() => component.value?.navigationGroup === 'Forms');

const label = computed(() => isForm.value ? 'form' : 'content type');

// --- Methods ---

const duplicateForm = () => {
    store.dispatch('modals/show', {
        componentName: 'ConfirmModal',
        obj: {
            modalTitle: 'Are you sure?',
            onConfirm: async () => {
                try {
                    // 1. Request the copy via API
                    const response = await store.dispatch('request/post', {
                        url: `api/component/modulecomponents?copyId=${component.value.id}`
                    });

                    const newTableName = response.data.tableName;

                    // 2. Re-initialize the global components list so the new one exists in state
                    await store.dispatch('components/init');

                    // 3. Navigate to the settings of the newly created component
                    router.push({
                        name: 'componentSettings',
                        params: { component: newTableName }
                    });
                } catch (error) {
                    console.error("Failed to duplicate component:", error);
                }
            }
        }
    });
};
</script>

<template>
    <div class="root">
        <div>
            <h5 class="list-group-item-heading">Duplicate this {{ label }}</h5>

            <p class="mb-0">
                Duplicates the {{ label }}'s settings and fields.
            </p>
        </div>

        <button class="btn btn-success ms-2" type="button" @click="duplicateForm">
            Duplicate this {{ label }}
        </button>
    </div>
</template>

<style scoped>
.root {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.root > :first-child {
    flex: auto;
}
</style>